module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ashou1-b9eae44a51c595044aa5eb305597bc49.jpg";